var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFuzoes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.07px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 2.23px;\n      }\n\n      .cls-3 {\n        stroke-width: 2.32px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.54,27.45c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-.18h4.76c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-4.73h-5.99v4.73h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v.18h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v.18h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v4.35h5.99v-4.35h4.76c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-.18h4.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.54,52.43c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-.18h4.76c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-4.73h-5.99v4.73h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v.18h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v.18h-4.8c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67h4.8v4.35h5.99v-4.35h4.76c.92,0,1.67-.75,1.67-1.67s-.75-1.67-1.67-1.67h-4.76v-.18h4.76Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.99,
    y: 35.62,
    width: 11.85,
    height: 4.91,
    rx: 2.46,
    ry: 2.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.17,
    y: 9.95,
    width: 38.51,
    height: 4.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.17,
    y: 60.6,
    width: 38.51,
    height: 4.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.23,
    y: 14.35,
    width: 3.68,
    height: 45.56
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFuzoes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FUZOES.d861795be5a10eb8c4be556411d7500c.svg";